import AttractLoop from "./AttractLoop.component";

export default AttractLoop;
